__turbopack_context__.v({
  "actions": "dabIDa_actions",
  "checkmark": "dabIDa_checkmark",
  "content": "dabIDa_content",
  "description": "dabIDa_description",
  "iconPrimary": "dabIDa_iconPrimary",
  "iconSecondary": "dabIDa_iconSecondary",
  "iconTertiary": "dabIDa_iconTertiary",
  "nextSteps": "dabIDa_nextSteps",
  "nextStepsLabel": "dabIDa_nextStepsLabel",
  "stepArrow": "dabIDa_stepArrow",
  "stepDescription": "dabIDa_stepDescription",
  "stepIconWrapper": "dabIDa_stepIconWrapper",
  "stepItem": "dabIDa_stepItem",
  "stepItemDisabled": "dabIDa_stepItemDisabled",
  "stepItemHighlighted": "dabIDa_stepItemHighlighted",
  "stepText": "dabIDa_stepText",
  "stepTitle": "dabIDa_stepTitle",
  "stepsList": "dabIDa_stepsList",
  "title": "dabIDa_title",
  "wrapper": "dabIDa_wrapper",
});
